import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_29282_1518)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M20.0003 0C25.3027 0.00584716 30.3867 2.11487 34.136 5.86426C37.8854 9.61372 39.9946 14.6975 40.0003 20C40.0003 23.9556 38.8268 27.8224 36.6292 31.1113C34.4316 34.4003 31.3081 36.9638 27.6536 38.4775C23.9991 39.9913 19.9776 40.3869 16.0979 39.6152C12.2185 38.8435 8.65468 36.9395 5.85771 34.1426C3.06066 31.3455 1.15579 27.781 0.384081 23.9014C-0.387497 20.0219 0.00910128 16.001 1.52275 12.3467C3.03642 8.69236 5.59927 5.5687 8.88799 3.37109C12.177 1.17347 16.0447 0 20.0003 0ZM26.3782 4.60156C23.3328 3.34011 19.9813 3.01024 16.7483 3.65332C13.5154 4.29639 10.546 5.88408 8.21514 8.21484C5.88437 10.5456 4.29676 13.5152 3.65361 16.748C3.01053 19.981 3.34043 23.3325 4.60185 26.3779C5.8633 29.4233 7.99974 32.0261 10.7405 33.8574C13.4813 35.6888 16.7039 36.667 20.0003 36.667C24.4189 36.662 28.6551 34.9038 31.7796 31.7793C34.904 28.6548 36.6615 24.4187 36.6663 20C36.6663 16.7036 35.6891 13.4811 33.8577 10.7402C32.0264 7.99953 29.4236 5.863 26.3782 4.60156ZM20.0003 27.5C21.3808 27.5002 22.5003 28.6194 22.5003 30C22.5003 31.3806 21.3808 32.4998 20.0003 32.5C18.6196 32.5 17.5003 31.3807 17.5003 30C17.5003 28.6193 18.6196 27.5 20.0003 27.5ZM20.0003 10C21.3458 10.0002 22.4039 11.1503 22.2923 12.4912L21.3538 23.7539C21.2951 24.4579 20.7066 24.9998 20.0003 25C19.2938 25 18.7045 24.458 18.6458 23.7539L17.7073 12.4912C17.5957 11.1501 18.6546 10 20.0003 10Z",
			fill: "#E69D15"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29282_1518",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgExclamation;
